import {LOGIN_ACTION,LOGOUT_ACTION} from '../actions/actions'
const initialState = {
    auth : null
}
export const authReducer = (state = initialState, action) => {
    switch (action.type) {
        case LOGIN_ACTION:

            return {
                auth: action.authUser
            }
        case LOGOUT_ACTION:
            return {
                auth: null
            }
        default:
            return state
    }
}